import { useTranslation } from 'react-i18next';

export function ClientOfferPageLoading() {
  const { t } = useTranslation('offers');
  return (
    <div className="flex min-h-screen items-center justify-center">
      <p className="text-sm text-muted-foreground">{t('clientOffer.loading')}</p>
    </div>
  );
}

export function ClientOfferPageError() {
  const { t } = useTranslation('offers');
  return (
    <div className="flex min-h-screen items-center justify-center">
      <p className="text-sm text-destructive">{t('clientOffer.error')}</p>
    </div>
  );
}

export function ClientOfferPageNotFound() {
  const { t } = useTranslation('offers');
  return (
    <div className="flex min-h-screen items-center justify-center">
      <p className="text-sm text-muted-foreground">{t('clientOffer.notPublished')}</p>
    </div>
  );
}
